<template>
  <div class="input-wrap" :class="{ 'is-row' :layout && layout === 'row', 'is-large': isLarge }">
    <label v-if="label" :for="id">{{label}}</label>
    <input
      :id="id"
      :type="type"
      :placeholder="placeholder"
      :autocomplete="autocomplete"
      v-model="localValue"
      :disabled="disabled"
      :required="required"
      :readonly="readonly"
      @input="emit"
      ref="element"
    />
  </div>
</template>

<script>
import isEmail from '@/utilities/isEmail';

export default {
  name: 'TextInput',
  props: {
    id: String,
    value: [String, Number, Date],
    type: String,
    label: String,
    placeholder: String,
    autocomplete: String,
    disabled: Boolean,
    readonly: Boolean,
    layout: String,
    required: Boolean,
    autofocus: Boolean,
    isLarge: Boolean,
  },
  watch: {
    value(val) {
      if (val !== this.localValue) {
        this.localValue = val;
      }
    },
  },
  data() {
    return {
      localValue: this.value,
      step: this.step || 'any',
    };
  },
  mounted() {
    if (this.autofocus) {
      this.$refs.element.focus();
    }
  },
  methods: {
    emit() {
      if (this.type === 'email') {
        const emitValue = isEmail(this.localValue) ? this.localValue : null;
        this.$emit('input', emitValue);
      } else {
        this.$emit('input', this.localValue);
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '@/styles/input.scss';

</style>
